import { useEffect, useMemo } from "react";
import moment from "moment";
import PropTypes from 'prop-types';

// @mui material components
import { Box, Card, Divider, Switch, Grid } from "@mui/material";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

import { useQuery, useMutation } from '@tanstack/react-query';

import clearwaysAPI from 'modules/clearways/api';
import groupsAPI from 'services/api/groups';
import bksAPI from 'services/api/bks';

import EventForm from "modules/clearways/components/EventForm";
import { useAuth0 } from "@auth0/auth0-react";
import { disableMap } from "utils/map";
import { wrapper, loadingScreen } from "utils/wrapper";
import { useSoftUIController } from "hooks/context";

function createEvent(data) {
    console.log(data);
    clearwaysAPI.createClearwayEvent(data);
}

function ClearwaysEventAdd({ map, user }) {
    disableMap(map);

    bksAPI.loadToken(useAuth0());
    groupsAPI.loadToken(useAuth0());
    const [controller] = useSoftUIController();
    const { deviceLayout } = controller;

    var event = {
        display_time: moment().add(1, 'hour').startOf('hour').format(),
        start_time: moment().add(5, 'day').add(1, 'hour').startOf('hour').format(),
        end_time: moment().add(5, 'day').add(4, 'hour').startOf('hour').format(),
        organisation_id: "clearways",
        is_multi_day: false,
        groups: [],
        cameras_enabled: false
    };

    const groups = useQuery({
        queryKey: ['getGroups', 0],
        queryFn: async () => {
            return await groupsAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices'],
        queryFn: async () => {
            return await bksAPI.getAllDevices();
        }
    });

    const { mutate } = useMutation({
        mutationFn: (values) => createEvent(values),
    })

    if (groups.isLoading || devices.isLoading) {
        return loadingScreen(deviceLayout, true);
    }

    if (groups.error || devices.error) {
        return wrapper("Error!", "Error!");
    }

    if (!groups.data || !devices.data) {
        return loadingScreen(deviceLayout, false);
    }

    return wrapper((
        <Box p={1}>
            <Card>
                <EventForm event={event} groups={groups.data} devices={devices.data} onSubmit={mutate} isAdd={true} />
            </Card>
        </Box>
    ), deviceLayout, true
    );
}

ClearwaysEventAdd.propTypes = {
    map: PropTypes.object,
    navTitle: PropTypes.array,
    setNavTitle: PropTypes.func,
    sidebarState: PropTypes.string,
    setSidebarState: PropTypes.func,
}

export default ClearwaysEventAdd;